export const state = () => ({
  userRoleList: [],
  createUserRoleSuccess: null,
  updateUserRoleSuccess: null,
  deleteUserRoleSuccess: null,
  regeneratePasswordUserRoleSuccess: null,
});
